module.exports = __webpack_public_path__ + "static/media/logo.67b1707a.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Login/images/logo.png
// module id = 361
// module chunks = 9